export class ChangeUserStatusModel {
    userSurrkey: number;
    userStatus: number;
}